import React from 'react';
import classNames from 'classnames';
import { withStyles } from './../../../../themes/default';

const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 1.5,
    //paddingTop: 38
  },
  noGutterTop: {
    paddingTop: 0
  },
  noGuttersSide: {
    paddingLeft: 0,
    paddingRight: 0
  },
  enabledActions: {
    paddingBottom: theme.spacing.unit * 6
  }
});

const FormContent = ({children, classes, disabledGuttersSide, disabledGutterTop, enabledActions, ...rest}) => {

  return (
    <div className={ classNames(
              classes.root,
              disabledGuttersSide ? classes.noGuttersSide : null,
              disabledGutterTop ? classes.noGutterTop : null,
              enabledActions ? classes.enabledActions : null,
            )}>
      { children }
    </div>
  )

}

export default withStyles(styles)(FormContent);
